import { FC, useState } from 'react';
import { Grid, IconButton, InputAdornment, MenuItem, TextField } from '@mui/material';
import { FiltersLayout, FiltersButtons } from '../../../components';
import { IDropdownResponse } from '../../../models';
import { Close } from '@mui/icons-material';

interface IStaffReassignmentFilterProps {
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;

  projectManagers: IDropdownResponse[] | [];
  setSelectedProjectManager: (val: string) => void;
  selectedProjectManager: string;

  supervisors: IDropdownResponse[] | [];
  setSelectedSupervisor: (val: string) => void;
  selectedSupervisor: string;
}

export const StaffReassignmentFilters: FC<IStaffReassignmentFilterProps> = ({
  isLoading,
  applyFilters,
  projectManagers,
  setSelectedProjectManager,
  selectedProjectManager,
  supervisors,
  setSelectedSupervisor,
  selectedSupervisor
}) => {
  const [hasAppliedFilters, setHasAppliedFilters] = useState<boolean>(false);

  return (
    <FiltersLayout>
      <Grid item xs={12} sm={6} md={4} xl={3}>
        <TextField
          select
          size="small"
          fullWidth
          variant="outlined"
          name="projectManagerId"
          label={isLoading ? 'Loading...' : 'Project Manager'}
          value={selectedProjectManager}
          disabled={isLoading}
          InputProps={{
            endAdornment: selectedProjectManager ? (
              <InputAdornment
                position="end"
                sx={{
                  position: 'absolute',
                  right: 27,
                  cursor: 'pointer'
                }}
              >
                <IconButton
                  component="span"
                  title="Clear"
                  size="small"
                  onClick={() => {
                    setSelectedProjectManager('');
                  }}
                >
                  <Close fontSize="small" />
                </IconButton>
              </InputAdornment>
            ) : null
          }}
          onChange={e => {
            setSelectedProjectManager(e.target.value as string);
          }}
        >
          {projectManagers &&
            projectManagers.map((manager, index) => {
              return (
                <MenuItem key={`${manager.value}-${index}`} value={manager.value}>
                  {manager.description}
                </MenuItem>
              );
            })}
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6} md={4} xl={3}>
        <TextField
          select
          size="small"
          fullWidth
          variant="outlined"
          name="supervisorId"
          label={isLoading ? 'Loading...' : 'Supervisor'}
          value={selectedSupervisor}
          disabled={isLoading}
          InputProps={{
            endAdornment: selectedSupervisor ? (
              <InputAdornment
                position="end"
                sx={{
                  position: 'absolute',
                  right: 27,
                  cursor: 'pointer'
                }}
              >
                <IconButton
                  component="span"
                  title="Clear"
                  size="small"
                  onClick={() => {
                    setSelectedSupervisor('');
                  }}
                >
                  <Close fontSize="small" />
                </IconButton>
              </InputAdornment>
            ) : null
          }}
          onChange={e => {
            setSelectedSupervisor(e.target.value as string);
          }}
        >
          {supervisors &&
            supervisors.map((supervisor, index) => {
              return (
                <MenuItem key={`${supervisor.value}-${index}`} value={supervisor.value}>
                  {supervisor.description}
                </MenuItem>
              );
            })}
        </TextField>
      </Grid>
      <Grid item xs={12} md={5} xl={3}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            applyFilters();
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            setSelectedProjectManager('');
            setSelectedSupervisor('');
            applyFilters(true);
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};
